module.exports = __webpack_public_path__ + "img/bImg2.9c286618.png";